import styles from './ModalCongratsRescue.module.css';

import Modal from 'react-responsive-modal';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../../components/Button';
import { useCart } from '../../../../hooks/useCart';
import * as routes from '../../../../constants/Routes';
import iconReedem from '../../../../assets/images/iconReedem.png';

interface IModalCongratsRescue {
  modalCongratsIsOpen: boolean;
  clientNumberOfDaysToRedeem: number | string;
}

export function ModalCongratsRescue({
  modalCongratsIsOpen,
  clientNumberOfDaysToRedeem,
}: IModalCongratsRescue) {
  const navigate = useNavigate();
  const { cart, clearCart } = useCart();

  const isAwardMoney = cart.some((item) => item.premiumType.value === 'BS2');
  const isAwardFisic = cart.some((item) => item.premiumType.value === 'Físico');
  const isAwardVoucher = cart.some(
    (item) => item.premiumType.value === 'digital'
  );

  const onHandleBackRedeemConfirmRescue = async () => {
    // Navega antes de limpar o carrinho (e sem recarregar a página): assim a
    // tela de "carrinho vazio" do ConfirmRescue nunca aparece atrás do modal
    navigate(isAwardMoney ? routes.REDEEM_AWARDS : routes.MY_RESCUES);
    sessionStorage.clear();
    clearCart();
  };

  return (
    <Modal
      open={modalCongratsIsOpen}
      onClose={onHandleBackRedeemConfirmRescue}
      center
    >
      <div>
        <div className="contents-modal">
          <div className="d-flex justify-content-center">
            <img
              className={styles.alert}
              src={iconReedem}
              alt="Cadastro confirmado"
            />
          </div>
          <h1 className="title-modal">Parabéns!</h1>
          {isAwardMoney && (
            <p className="subtitle-modal">
              Seu resgate foi feito com sucesso! Em {clientNumberOfDaysToRedeem}{' '}
              o dinheiro estará na sua conta.
            </p>
          )}
          {(isAwardVoucher || isAwardFisic) && (
            <p className="subtitle-modal">Seu resgate foi feito com sucesso!</p>
          )}
        </div>
        <div className={styles.contentBtn}>
          <Button
            style={{
              width: '100%',
              borderRadius: '0px',
              textTransform: 'uppercase',
              fontWeight: 'bold',
            }}
            text="Confirmar"
            type="button"
            color="primary"
            onClick={onHandleBackRedeemConfirmRescue}
          />
        </div>
      </div>
    </Modal>
  );
}
